/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { addTrackingInformationSuffix } from '../../services/UrlService';
import { Flex, Image, Text } from '@getgo/chameleon-chakra-ui';
import { Link } from '../Link/Link';
import { isMobileJoinTechnicallySupported } from '../../services/ProductCompatibilityService';
import { isIE, isMobile } from '../../services/ClientService';
import { InfoBanner } from '../Banner/InfoBanner';
import { AppBanner } from '../Banner/AppBanner';

const support = 'https://link.gotomeeting.com/launcher';
const g2m = 'https://link.gotomeeting.com';
const covid19URL =
  'https://support.goto.com/gotomeeting/help/covid-19-tips-for-staying-secure-using-gotomeeting';

const messages = defineMessages({
  support: {
    id: 'header.support',
  },
  ariaLabel: {
    id: 'header.ariaHomepage',
  },
  infoBannerText: {
    id: 'infoBanner.securityTip',
  },
  infoBannerLink: {
    id: 'infoBanner.securityTipLink',
  },
});

export const Header = () => {
  const { formatMessage: f } = useIntl();
  const iconWidth = isMobileJoinTechnicallySupported ? '160px' : '240px';
  return (
    <Flex direction='column' id='header' role='heading' aria-level={1}>
      {!isIE && (
        <InfoBanner
          localStorageId='showBanner'
          text={f(messages.infoBannerText)}
          linkText={f(messages.infoBannerLink)}
          url={addTrackingInformationSuffix(covid19URL)}
        />
      )}
      {isMobile && <AppBanner />}
      <Flex p={6} justifyContent='space-between'>
        <Link isExternal={true} href={g2m} aria-label={f(messages.ariaLabel)}>
          <Image
            width={iconWidth}
            src={`${process.env.PUBLIC_URL}/static/media/g2mLogo.svg`}
            alt='GoToMeeting'
          />
        </Link>
        <Link isExternal={true} href={support}>
          <Text textTransform='uppercase' fontSize='0.8125rem'>
            {f(messages.support)}
          </Text>
        </Link>
      </Flex>
    </Flex>
  );
};
